import React from 'react';
import { IntlProvider } from 'react-intl';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import zhCN from '../../locales/zh-CN';
import enUS from '../../locales/en-US';
import ar from '../../locales/ar';
import ruRU from '../../locales/ru-RU';

dayjs.locale('en');

/**
 * "zh-CN": zhCN,
 * "zh-TW": zhCN,
 * "zh-HK": zhCN,
 * "en-US": enUS,
 */
const messages: { [key in string]: any } = {
  zh: zhCN,
  en: enUS,
  ar: ar,
  ru: ruRU,
};

export const formatIntlProviderLocale = (language: string) => {
  return language.replace('_', '-');
};

export const formatIntlProviderMessages = (language: string) => {
  return messages[language.split('_')[0]];
};

/** 国际化组件 */
const LocalIntlProvider: React.FC<{ children: React.ReactNode; language: string }> = (props) => {
  const { children, language } = props;

  return (
    <IntlProvider
      locale={formatIntlProviderLocale(language)}
      messages={formatIntlProviderMessages(language)}
      defaultLocale="en-US"
    >
      {children}
    </IntlProvider>
  );
};

export default LocalIntlProvider;
